export default "__VITE_ASSET__Yk7tSd43__"